import { t } from "i18next";
import { observer } from "mobx-react-lite";
import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { DeleteButtonStd } from "src/components/DeleteButtonStd/DeleteButtonStd";
import { LoaderBox } from "src/components/LoaderBox";
import { PageLayout } from "src/components/PageLayout";
import { makeUrl } from "src/routes/makeUrl";
import { PageUrl } from "src/routes/PageUrl";
import { ZRole, ZRoleSaveData } from "src/types";

import { RoleForm } from "./RoleForm";
import { singleRoleStore } from "./SingleRoleStore";

export const SingleRolePage: React.FC = observer(() => {
  const { id } = useParams<{ id: string }>();
  useEffect(() => {
    singleRoleStore.loadRole(id);
    return () => {
      singleRoleStore.clear();
    };
  }, [id]);

  return (
    <PageLayout title={singleRoleStore.crumbs}>
      <LoaderBox
        remoteData={singleRoleStore.data}
        drawReady={(data) => <Inner data={data} />}
      />
    </PageLayout>
  );
});

type PropsInner = {
  data: ZRole | null;
};

const Inner: React.FC<PropsInner> = observer(({ data }) => {
  const navigate = useNavigate();
  const handleSubmit = async (formData: ZRoleSaveData) => {
    singleRoleStore.saveRole(formData).then((result) => {
      if (result) {
        navigate(makeUrl(PageUrl.managementRoleEdit, { id: result.id }));
      }
    });
  };
  const handleCancel = () => navigate(makeUrl(PageUrl.managementRoles));

  const handleDelete = () =>
    singleRoleStore.deleteRole().then(() => {
      navigate(makeUrl(PageUrl.managementRoles));
    });
  return (
    <RoleForm
      sourceData={data ?? undefined}
      disabled={singleRoleStore.data.status !== "ready"}
      saving={singleRoleStore.loading}
      extraButtons={
        singleRoleStore.roleId && (
          <DeleteButtonStd
            task={handleDelete}
            content={t("Delete [entity]", { entity: t("Role") })}
            successMsg={t("Deleted successfully [entity]", {
              entity: t("Role"),
            })}
          />
        )
      }
      onSubmit={handleSubmit}
      onCancel={handleCancel}
    />
  );
});
